import { useApiClient } from '@/api/util/useApiClient.util.ts';
import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import fileDownload from 'js-file-download';

type Req = {
  adminUserId: string;
  email: string;
};

type Response = void;

type Return = {
  downloadCandidateFullAudit: (req: Req) => Promise<Response>;
  isDownloading: boolean;
};

export const useDownloadCandidateFullAudit = (): Return => {
  const { adminCandidatesApi } = useApiClient();
  const { isPending, mutateAsync } = useMutation<Response, AxiosError, Req>({
    mutationFn: async req => {
      const response = await adminCandidatesApi.downloadCandidateFullAudit(
        req.adminUserId,
        req.email,
        {
          responseType: 'blob',
        },
      );
      const fileName =
        response.headers['content-disposition'].match(/attachment; filename=(.*)/)[1] ??
        'candidate-audit.xlsx';
      fileDownload(response.data, fileName, 'application/octet-stream');
    },
  });

  return {
    downloadCandidateFullAudit: mutateAsync,
    isDownloading: isPending,
  };
};
